var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "348.000000pt",
    height: "348.000000pt",
    viewBox: "0 0 348.000000 348.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,348.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1590 3115 c-153 -31 -281 -98 -398 -209 -111 -105 -178 -211 -222 -351 -33 -107 -39 -311 -12 -426 60 -249 223 -447 454 -553 461 -211 1000 46 1128 539 29 111 29 289 0 400 -80 310 -326 541 -638 601 -90 17 -224 17 -312 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 1422 c-38 -21 -93 -54 -120 -74 -78 -57 -209 -199 -270 -293 -127 -196 -225 -466 -236 -655 l-3 -55 1398 -3 1397 -2 0 44 c0 172 -109 473 -247 681 -110 165 -295 330 -428 381 l-42 16 -66 -47 c-265 -185 -634 -235 -952 -129 -98 33 -169 68 -259 128 -38 25 -76 46 -85 46 -9 0 -48 -17 -87 -38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.4c2a1319c74a8404157cd8104a17ab4a.svg";
export { ForwardRef as ReactComponent };